export const POPUP_MINIMUM_DELAY_BEFORE_SHOW_MS = 20000;
export const POPUP_MINIMUM_SCROLL_BEFORE_SHOW_PX = 1000;

export const POPUP_BACKOFF_SCHEDULE = [
  24 * 3600 * 1000, // 24 hours.
  4 * 24 * 3600 * 1000, // 4 days.
  16 * 24 * 3600 * 1000, // 16 days.
  32 * 24 * 3600 * 1000 // 32 days.
];
